import { render, staticRenderFns } from "./popup-detail.vue?vue&type=template&id=1975053c&"
import script from "./popup-detail.vue?vue&type=script&lang=js&"
export * from "./popup-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports